import React from 'react';
import './Footer.css'

export const Footer = () => {
    return(
        <footer id="footer">&copy; 2021 Gonda Armand</footer>
    )
} 